import { observer } from "mobx-react";
import { FC, useEffect, useState } from "react";
import styled from "styled-components";

const ServiceBlock = styled.div`
  padding: 0px 15px;
  border-radius: 8px;
  border: 1px solid #e0e0e0;
  display: flex;
  background: white;
  align-items: center;
  width: calc(100% - 32px);
  @media(max-width: 480px) {
    background: var(--gray, #F5F5F8);
  }
`;

const SaleMark = styled.div`
  border-radius: 5px;
  background: red;
  color: white;
  padding-left: 5px;
  padding-right: 5px;
  margin-left: 5px;
  ::before {
    content: "sale";
    font-size: 14px;
  }
`;

const Price = styled.p`
  margin-left: auto;
  font-style: italic;
  opacity: 0.4;
`;

const InputCheckbox = styled.input`
  margin-right: 8px;
`;

const SelectService: FC<{ name: string; price: number; sale: boolean; onClick: Function }> = observer(({ name, price, sale, onClick }) => {
  const [selected, setSelected] = useState<boolean>(false);

  // Если сюда добавить в массив onClick, то начнется бесконечный цикл в компонентах, использующих это
  // eslint-disable-next-line
  useEffect(() => onClick(selected), [selected]);

  return (
    <ServiceBlock onClick={() => setSelected(prev => !prev)}>
      <div style={{ display: "flex" }}>
        <InputCheckbox type="checkbox" id={name} checked={selected} onChange={({ target }) => setSelected(target.checked)} />
        <label htmlFor={name} onClick={() => setSelected(prev => !prev)}>{name}</label>
      </div>
      {sale && <SaleMark />}
      <Price>{price}р</Price>
    </ServiceBlock>
  );
});

export default SelectService;
